import React from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material UI
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

// Helpers
import { currencyFormat } from 'helpers/currencyFormat';

// Types
import { EmtuReportMonthInterface } from 'store/ducks/reports/types';
import { ApplicationState } from 'store';

// Components

interface SubRowProps {
  monthsResult: EmtuReportMonthInterface[];
  collapseClassRow: string;
  balance?: number;
}

const SubRow: React.FC<SubRowProps> = ({
  monthsResult,
  collapseClassRow,
  balance,
}) => {
  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const getTotal = (result: EmtuReportMonthInterface) => {
    const { buyValue, usageValue } = result;
    return buyValue - usageValue;
  };
  return (
    <>
      {monthsResult.map((result, index) => {
        if (index === monthsResult.length - 1) {
          return (
            <>
              <TableRow className={collapseClassRow}>
                <TableCell />
                <TableCell>{result.month}</TableCell>
                <TableCell> {result.buys}</TableCell>
                <TableCell>
                  {' '}
                  {result.buyValue
                    ? currencyFormat({
                        value: Number(result.buyValue),
                      })
                    : null}
                </TableCell>
                <TableCell>{result.usages}</TableCell>
                <TableCell>
                  {result.usageValue
                    ? currencyFormat({
                        value: Number(result.usageValue),
                      })
                    : null}
                </TableCell>
                <TableCell>
                  {' '}
                  {getTotal(result)
                    ? currencyFormat({
                        value: Number(getTotal(result)),
                      })
                    : null}
                </TableCell>
                <TableCell />
                {transportOperatorSelected.type === 1 && <TableCell />}
              </TableRow>

              <TableRow className={collapseClassRow}>
                <TableCell />
                <TableCell>
                  {' '}
                  <Typography style={{ fontWeight: 500 }}>
                    Saldo
                  </Typography>{' '}
                </TableCell>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell>
                  {' '}
                  <Typography style={{ fontWeight: 500 }}>
                    {typeof balance === 'number'
                      ? currencyFormat({
                          value: Number(balance),
                        })
                      : '--'}
                  </Typography>{' '}
                </TableCell>
                <TableCell />
                {transportOperatorSelected.type === 1 && <TableCell />}
              </TableRow>
            </>
          );
        }

        return (
          <TableRow className={collapseClassRow}>
            <TableCell />
            <TableCell>{result.month}</TableCell>
            <TableCell> {result.buys}</TableCell>
            <TableCell>
              {' '}
              {result.buyValue
                ? currencyFormat({
                    value: Number(result.buyValue),
                  })
                : null}
            </TableCell>
            <TableCell>{result.usages}</TableCell>
            <TableCell>
              {result.usageValue
                ? currencyFormat({
                    value: Number(result.usageValue),
                  })
                : null}
            </TableCell>
            <TableCell>
              {getTotal(result)
                ? currencyFormat({
                    value: Number(getTotal(result)),
                  })
                : null}
            </TableCell>
            <TableCell />
          </TableRow>
        );
      })}
    </>
  );
};

export { SubRow };
export default SubRow;
